(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3RenewNotification', {
            templateUrl: 'app/shared/renew-notification/renew-notification.component.html',
            controller: RenewNotificationComponent
        });

    RenewNotificationComponent.$inject = ['$rootScope', 'user', 'localStorageService', 'renewConfirmationDateStorageKey', 'clubMembershipLevelType'];
    function RenewNotificationComponent($rootScope, user, $localStorage, storageKey, clubMembershipLevelType) {
        var ctrl = this;
        ctrl.isVisible = false;
        ctrl.$onInit = init;
        ctrl.close = close;

        ctrl.isClubManagingUpgrades = user.isClubManagingUpgrades;
        ////////////////////////////////

        function init() {
            $rootScope.$watch(userWatch, userWatchAction);
        }

        function close() {
            $localStorage.set(storageKey, new Date());
            ctrl.isVisible = false;
        }

        function daysBetween(start, end) {
            return Math.round((end - start) / (1000 * 60 * 60 * 24));
        }

        function userWatch() {
            return user.id;
        }

        function userWatchAction(value) {
            var expiration = user.expirationDate,
                membershipLevel = user.membershipLevel,
                isDefaultMembershipLevel = membershipLevel === clubMembershipLevelType.Default,
                expiresIn = expiration && daysBetween(Date.now(), expiration),
                confirmationDate = expiresIn && $localStorage.get(storageKey),
                daysSinceConfirmation = confirmationDate && daysBetween(confirmationDate, Date.now()),
                hasBeenMoreThanWeek = daysSinceConfirmation === null || daysSinceConfirmation < 0 || daysSinceConfirmation > 7;

            if (user.subscriptionRenewsOn === null)                            
                ctrl.isVisible = !isDefaultMembershipLevel && expiresIn > 0 && (expiresIn <= 7 || (expiresIn <= 30 && hasBeenMoreThanWeek));
            else
                ctrl.isVisible = false;            
        }
    }
})();
